import { Component, Input } from '@angular/core';
import { TabData } from '@ddt-web/data-service';

import { SeriesLabelIcon } from '../enums/series-label-icon.enum';
import { GroupConfiguration } from '../performance-overview/models/group-configuration.interface';

@Component({
	selector: 'perf-performance-chart-grouped-legend',
	templateUrl: './performance-chart-grouped-legend.component.html',
	styleUrls: ['./performance-chart-grouped-legend.component.scss']
})
export class PerformanceChartGroupedLegendComponent {
	@Input() public chartData: Array<TabData>;
	@Input() public groupingConfiguration: Array<GroupConfiguration>;
	@Input() public seriesColors: Array<Array<string>>;
	@Input() public seriesLabelIcon: SeriesLabelIcon;
	@Input() public isTableDataPerPortfolio: boolean = false;

	public SeriesLabelIcon = SeriesLabelIcon;
}
